import WidgetClassListPagingResultModelBase from '../_generated/modelBases/widget-class-list-paging-result-model-base';

export default class WidgetClassListPagingResultModel extends WidgetClassListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
